import CityPageTemplate from "../hawaii-city/CityPageTemplate";
import { kiheiConfig } from "./data";

export default function Page() {
  return <CityPageTemplate config={kiheiConfig} />;
}